import React, { Component } from 'react'
import { stopSubmit, clearFields } from 'redux-form'
import { bindActionCreators } from 'redux'
import store from 'services/store'
import { connect } from 'react-redux'
import ReduxCustomEventForm from 'components/Forms/CustomEvent'
import moment from 'moment'
import { halfHourInMilliseconds } from 'app/services/date'
import {
  getEventPayload,
  getEvent,
  getCustomEventInitialValues,
  getEventParticipants
} from 'app/selectors/customEvent'
import { CustomEventActionCreators } from 'app/reducers/CustomEventRedux'

class ConnectedCustomEventForm extends Component {
  submit = () => {
    const { event } = this.props

    if (event) {
      this.props.actions.updateCustomEvent(event.id, this.props.eventPayload)
    } else {
      this.props.actions.createCustomEvent(this.props.eventPayload)
    }
  }

  cancel = () => {
    this.props.actions.setEvent(null)
    this.props.actions.setAddingOrEditingCustomEvent(false)
  }

  render() {
    return (
      <ReduxCustomEventForm
        initialValues={this.props.eventInitialValues}
        participants={this.props.eventParticipants}
        onCancel={this.cancel}
        onSubmit={this.submit}
      />
    )
  }
}

const mapStateToProps = state => ({
  eventPayload: getEventPayload(state),
  event: getEvent(state),
  eventInitialValues: getCustomEventInitialValues(state),
  eventParticipants: getEventParticipants(state),
  createCustomEvent: store.create('appointment').selector(state),
  updateCustomEvent: store.patch('appointment').selector(state)
})

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      createCustomEvent: store.create('appointment').action,
      updateCustomEvent: store.patch('appointment').action,
      eventsRequest: store.between('appointment').action,
      setAddingOrEditingCustomEvent:
        CustomEventActionCreators.setAddingOrEditingCustomEvent,
      setEvent: CustomEventActionCreators.setEvent
    },
    dispatch
  )
})

export default connect(mapStateToProps, mapDispatchToProps)(
  ConnectedCustomEventForm
)
